type TabsProps = {
  children: any;
}

export const Tabs = (props: TabsProps) => {
  return (
    <div className="flex border border-gray-300 rounded-lg overflow-hidden">{props.children}</div>
  )
}

type TabProps = {
  id: number;
  active: boolean;
  children: any;
  onClick: any;
}

export const Tab = (props: TabProps) => {
  return (
    <button id={`${props.id}`} onClick={props.onClick} className={`w-1/2 py-2.5 text-13 text-center font-bold cursor-pointer text-gray-700 ${!props.active ? "bg-gray-100 opacity-50" : ""} ${props.id === 1 ? "border-0 border-l border-r border-gray-300" : ""} lg:w-28 lg:text-base lg:py-2.5 px-3`}>{props.children}</button>
  )
}

type ContentProps = {
  active: boolean;
  children: any;
}

export const Content = (props: ContentProps) => {
  return (
    <div className={`${props.active ? "" : "hidden"}`}>{props.children}</div>
  )
}
